// An object, never a bare string: synapse's `DefaultPayload` requires a record payload.
export type OrganizationWorkflowDeactivatedPayload = {
	workflowKey: string;
};

export type OrganizationWorkflowDeactivatedAction = {
	type: 'ORGANIZATION_WORKFLOW_DEACTIVATED';
	payload: OrganizationWorkflowDeactivatedPayload;
	organizationId: number;
};

export default (
	payload: OrganizationWorkflowDeactivatedPayload,
	organizationId: number,
): OrganizationWorkflowDeactivatedAction => ({
	type: 'ORGANIZATION_WORKFLOW_DEACTIVATED',
	payload,
	organizationId,
});
